import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadLocale3(action) {
  var payload = {
    action: "portal/loadLocale3",
    locale: action.locale,
  };
  yield put(serverRequest(payload));
}

export default loadLocale3;
